import React from "react";

export default function MySQL_FORMAT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_FORMAT</h1>
      <p>This is the MySQL_FORMAT component generated from the SQL JSON.</p>
    </div>
  );
}
